import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import SendIcon from '@material-ui/icons/Send';
import { ICONS, PATH } from 'app.routes.const';
import { NAME_SPACE } from 'i18n';
import { FormPage, isSkeletonLoading, Button, ORDER_STATUSES } from 'shared';

import { useOrder } from './useOrder';
import { FormOrder } from './FormOrder';
import { ROLES } from 'auth';
import { UserContext } from 'auth';

export function EditOrder() {
  const { id } = useParams();
  const { order, editOrderStatus } = useOrder(id);
  const { t } = useTranslation(NAME_SPACE.ORDERS);
  const history = useHistory();
  const { hasRole } = useContext(UserContext);
  const hasAdminRole = useMemo(() => hasRole([ROLES.ADMIN]), [hasRole]);

  return (
    <FormPage
      title={
        <>
          {ICONS.ORDERS}&nbsp;&nbsp;
          {`${t('singularName')}`}
          {!isSkeletonLoading(order.installation) && order.installation && order.id && ` | ${order.installation}`}
        </>
      }
      disabled
      onBack={() => history.push(PATH.ORDERS.LIST)}
      unstyled
      extraActions={
        <>
          {hasAdminRole && order?.status === ORDER_STATUSES.pending && (
            <Button
              icon={<SendIcon />}
              text={t('buttons.tagsCreated')}
              onClick={() => editOrderStatus(ORDER_STATUSES.created)}
            />
          )}
        </>
      }
    >
      <FormOrder order={{ ...order }} />
    </FormPage>
  );
}
